import {gql} from '@apollo/client';

export const DOWNLOAD_SORTER_PLAN_CHUTE_TEMPLATE = gql`
    query DownloadSorterPlanChuteTemplate($sorterId: Long!, $language: String!) {
        downloadSorterPlanChuteTemplate(sorterId: $sorterId, language: $language)
    }
`;

